import axios from "axios";

export default {
  async create(formData) {
    return axios.post(`/daily-tips`, formData);
  },
  async findAll(formData) {
    return axios.get(`/daily-tips/${formData.year}/${formData.month}`);
  },
  async delete({ id }) {
    return axios.delete(`/daily-tips/${id}`);
  },
};
